import { Entertainment, Politics } from "../../category";
import StyleOne from "../styleOne/StyleOne";
import StyleThree from "../styleThree/StyleThree";
import { StyleTwo } from "../styleTwo/StyleTwo";
import "./MainBodyFour.scss";

import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { getPosts } from "../../redux/features/post/postSlice";

import moment from "moment";
import DOMPurify from "dompurify";
import { shortenText } from "../../utils";
import HeadingTitle from "../headingTitle/HeadingTitle";
import { MdOutlineThumbUpOffAlt, MdVisibility } from "react-icons/md";
import { IoMdChatboxes } from "react-icons/io";

import { Link } from "react-router-dom";

const MainBodyFour = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getPosts());
  }, [dispatch]);
  const { posts } = useSelector((state) => state.post);
  const technology = posts.find((post) => post.category === "Technology");
  const travels = posts.find((post) => post.category === "Travel");

  const technologyB = posts
    ?.filter((tech) => {
      return tech?.category === "Technology";
    })
    ?.filter((tech, index) => index < 4);

  const travelB = posts
    ?.filter((travel) => {
      return travel?.category === "Travel";
    })
    ?.filter((caa, index) => index < 4);

  return (
    <div className="mainBodyFour">
      <div className="mainBodyFourWrapper">
        <div className="styleOne1">
          {/* StyleTwo Left  National*/}
          <div className="item">
            <div className="styleTwo">
              <HeadingTitle title={travels?.category} />
              <div className="top">
                <img src={travels?.image[0]} alt="" />
                <Link className="cat">{travels?.type}</Link>
                <Link className="icon">
                  {" "}
                  <MdVisibility style={{ fontSize: "20px" }} />
                </Link>

                {/* <div className="postInfo">
                  <ul className="nav">
                    <li>{national?.author}</li>
                    <li>{d}</li>
                  </ul>
                  <h3
                    dangerouslySetInnerHTML={{
                      __html: DOMPurify.sanitize(
                        shortenText(national?.title, 50)
                      ),
                    }}
                  ></h3>
                </div> */}
              </div>

              <div className="bottom">
                {travelB.map((travel) => {
                  return (
                    <div className="item" key={travel._id}>
                      <div className="left">
                        <Link to={`/page/${travel.slug}`}>
                          <img src={travel?.image[0]} alt="" />
                        </Link>
                        <div className="likeComment">
                          <div className="left">
                            <div className="lkicon">
                              <MdOutlineThumbUpOffAlt
                                color="#ff9f31"
                                size={20}
                              />
                              {travel?.likes?.length > 0 &&
                                travel?.likes?.length}
                            </div>
                          </div>
                          <div className="right">
                            <div className="cmticon">
                              <IoMdChatboxes color="#ff9f31" size={20} />
                              {travel?.comments?.length > 0 &&
                                travel?.comments?.length}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="right">
                        <ul className="nav">
                          <li>{travel?.author}</li>
                          <li>
                            {moment(travel.createdAt).format("DD-MMM-YYYY")}
                          </li>
                        </ul>

                        <Link to={`/page/${travel.slug}`}>
                          <h3
                            dangerouslySetInnerHTML={{
                              __html: DOMPurify.sanitize(
                                shortenText(travel?.title, 50)
                              ),
                            }}
                          ></h3>
                        </Link>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>

        <div className="styleOne1">
          {/* StyleTwo right  Movies*/}
          <div className="item">
            <div className="styleTwo">
              <HeadingTitle title={technology?.category} />

              <div className="top">
                <img src={technology?.image[0]} alt="" />
                <Link className="cat">{technology?.type}</Link>
                <Link className="icon">
                  {" "}
                  <MdVisibility style={{ fontSize: "20px" }} />
                </Link>

                {/* <div className="postInfo">
                  <ul className="nav">
                    <li>{movies?.author}</li>
                    <li>{d}</li>
                  </ul>
                  <h3
                    dangerouslySetInnerHTML={{
                      __html: DOMPurify.sanitize(
                        shortenText(movies?.title, 50)
                      ),
                    }}
                  ></h3>
                </div> */}
              </div>

              <div className="bottom">
                {technologyB.map((tech) => {
                  return (
                    <div className="item" key={tech._id}>
                      <div className="left">
                        <Link to={`/page/${tech.slug}`}>
                          <img src={tech?.image[0]} alt="" />
                        </Link>
                        <div className="likeComment">
                          <div className="left">
                            <div className="lkicon">
                              <MdOutlineThumbUpOffAlt
                                color="#ff9f31"
                                size={20}
                              />
                              {tech?.likes?.length > 0 && tech?.likes?.length}
                            </div>
                          </div>
                          <div className="right">
                            <div className="cmticon">
                              <IoMdChatboxes color="#ff9f31" size={20} />
                              {tech?.comments?.length > 0 &&
                                tech?.comments?.length}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="right">
                        <ul className="nav">
                          <li>{tech?.author}</li>
                          <li>
                            {moment(tech.createdAt).format("DD-MMM-YYYY")}
                          </li>
                        </ul>
                        <Link to={`/page/${tech.slug}`}>
                          <h3
                            dangerouslySetInnerHTML={{
                              __html: DOMPurify.sanitize(
                                shortenText(tech?.title, 50)
                              ),
                            }}
                          ></h3>
                        </Link>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>

        {/* StyleThree Right*/}
        {/* Voting poll */}
        <div className="styleThree3">{/* <StyleThree /> */}</div>
      </div>
    </div>
  );
};
export default MainBodyFour;
